import React from 'react';
import properties from '../../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';


export default class BrandDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errored: false };

    this.handleError = this.handleError.bind(this);
  }

  handleError(event) {
    this.setState({ errored: true });
  }

  render() {
    const brandDetails = this.props.brandDetails[0];
    const { newDesignLuxe } = this.props;
    return (
      <div className="comp-section" id="brandDetails">
        <h3 role="heading" aria-level={2} className="align-center">
          <span>About {brandDetails.brandName}</span>
        </h3>
        <div className="brand-section">
          {!this.state.errored && (
            <div className="brand-img">
              <img
                src={`${replaceWithJioCDN(brandDetails.aboutBrandImgUrl)}`}
                onError={this.handleError}
                alt={brandDetails.brandName || 'brand'}
              />
            </div>
          )}
          <div className="brand-desc">
            <div dangerouslySetInnerHTML={{ __html: brandDetails.catDescription }} />
            <p className="brnd-url">
              <a href={`${brandDetails.categoryUrl}`}>
                {newDesignLuxe
                  ? 'View all styles from this brand'
                  : 'View all styles from this brand >'}
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
